

module.exports = __webpack_require__.stylable.create(
    "PlanName2786944449",
    {"classes":{"root":"PlanName2786944449__root","planTitle":"PlanName2786944449__planTitle"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "PlanName2786944449",
    null
);
